<template>
  <item-select v-model="age"
               :style="multiple ? '' : 'width: 100px'"
               :options="options"
               :disabled="disabled"
               :multiple="multiple"
               :hints="hints"
               allow-create />
</template>
<script>
import LibProductItem from '../../../minxin/ProductItem';

export default {
  name: "ProductItemTypeAge",
  mixins: [LibProductItem],
  props: {
    value: [Number, Array],
  },
  computed: {
    options() {
      return this.list || this.ageOptions()
    },
    age: {
      get() { return this.dd },
      set(n) {
        if (this.multiple) {
          let vs = []
          for (let v of n) {
            if (/^\d{1,4}/.exec(n) === null) {
              return;
            }
            vs.push(parseInt(v))
          }
          this.$emit('input', vs)
        } else {
          if (/^\d{1,4}/.exec(n) === null) {
            return;
          }
          n = parseInt(n)
          this.$emit('input', n)
        }
      }
    }
  }
}
</script>
